'use client';
import { ICommit } from '@/types';

import * as Styled from './styled';
import { toTimeAgo } from '@/lib/dateTime';
import { IRemoteWorkspace } from '@/lib/workspaces/workspaceApi';

export const CommitInfo: React.FC<{ commit: ICommit }> = ({ commit }) => {
  return (
    <Styled.CommitInfo>
      {/* <UserAvatar user={user} size={12} /> */}
      <span>by {commit.author}</span>・<span>{toTimeAgo(commit.timestamp)}</span>
    </Styled.CommitInfo>
  );
};

export const WorkspaceUpdatedInfo: React.FC<{ workspace: IRemoteWorkspace }> = ({ workspace }) => {
  return (
    <Styled.CommitInfo>
      <span>by {workspace.user.username}</span>・<span>{toTimeAgo(workspace.updated_at)}</span>
    </Styled.CommitInfo>
  );
};
